import ITokenExpiredHttpErrorResponse from '../../interfaces/BadRequest/ITokenExpiredHttpErrorResponse';
import BadRequestHttpError from '../BadRequestHttpError';

export default class TokenExpiredHttpError extends BadRequestHttpError<ITokenExpiredHttpErrorResponse> {
    constructor(response: ITokenExpiredHttpErrorResponse) {
        super('Token expired!', response);
    }
}
